/**
 * Which calendar the user just checked on, given the multi-select picker's selection before and after a
 * change. Both pickers keep selections in visible list order, so
 * the changed array's last id is not reliably "what was just activated" — an uncheck can leave some
 * pre-existing id trailing at the end without it having been (re)activated. Diffing against the previous
 * selection is what tells the two apart: `undefined` means the change was an uncheck (or a clear), and
 * nothing should be recorded as newly active.
 *
 * Assumes at most one id is ever added per call (true for both current callers, which each diff a single
 * toggle). A multi-id addition would return the first new id, not necessarily the last-activated one.
 */
export function justActivatedCalendarUid(
  previousIds: readonly string[],
  nextIds: readonly string[],
): string | undefined {
  const previous = new Set(previousIds);
  return nextIds.find((id) => !previous.has(id));
}
